<template>
    <div class='menu'>
        <transition mode="out-in" name="slide-fade">
            <div v-if="current === 'home'" style="width:100%; height: 100%">
                <div class='menu__item' style="padding-top:0" @click="() =>switchState({new: 'random'})">Au hasard</div>
                <div class='menu__item' @click="switchState({new:'categories'})">Catégories</div>
                <div class='menu__item' @click="switchState({new:'liked'})">Sauvegardées</div>
                <div class='menu__item' @click="() =>switchState({new: 'about'})">A propos</div>
            </div>
            <About v-else-if="current === 'about'" :previous="previous"/>
            <CardList v-else :list="list" :name="name" :switch-state="switchState" :previous="previous"/>
        </transition>
    </div>
</template>

<script>
    import About from './About'
    import CardList from "./CardList";

    export default {
        props: ["switchState", "current", "list", "name", "previous"],
        components: {About, CardList}
    }
</script>

<style scoped>
    .menu {
        width: 90vw;
        max-width: 500px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        text-align: left;
        text-indent: 1.5em;
        overflow: hidden;
        padding-top: 5vh;
        margin-left: auto;
        margin-right: auto;
    }

    .menu__item {
        color: black;
        font-size: 1em;
        font-weight: bold;
        border-bottom: 2px solid black;
        width: 100%;
        padding-top: 4vh;
        padding-bottom: 1vh;
    }

        /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .5s;
    }
    .slide-fade-leave-active {
        transition: all .3s;
    }
    .slide-fade-enter{
        transform: translateY(-20px) translateX(-10px);
    }
    .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>